import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { EditOutlined, Lock, LockOpen } from '@mui/icons-material';

import { columns } from './columns';
import { Container, Content, Button } from './styles';
import api from '../../services/api';
import { IActionColumn } from '../../components/DevExpressTable/ActionsColumn';
import Table from '../../components/DevExpressTable/DevExpressTable';

interface Survey {
  surveyId: number;
  title: string;
  name: string;
  isLocked: boolean;
  isLockedIcon: React.ReactElement<any>;
  year: number;
}

interface State {
  projectName: string;
}

const Surveys: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [surveys, setSurveys] = useState<Survey[]>([]);
  const { projectId } = useParams();
  const location = useLocation();
  const state = location.state as State;
  const [tableColumnExtensions] = useState([
    { columnName: 'isLockedIcon', width: 110 },
    { columnName: 'surveyId', width: 60 },
    { columnName: 'year', width: 80 },
    { columnName: 'edit', width: 60 },
  ]);

  const handleClickEdit = useCallback(
    (row: any) => {
      navigate(`/surveys/${row.surveyId}`, { state: row.subGroup });
    },
    [navigate],
  );

  const [actionColumns] = useState<IActionColumn[]>([
    {
      columnName: 'edit',
      label: 'Edit',
      onClick: handleClickEdit,
      icon: <EditOutlined />,
    },
  ]);

  useEffect(() => {
    setLoading(true);

    const requestUrl = projectId ? `/surveys/project/${projectId}` : '/surveys';

    api.get(requestUrl).then(response => {
      const surveysResponse = response.data.map((x: Survey) => {
        return {
          ...x,
          isLockedIcon: !x.isLocked ? <LockOpen /> : <Lock />,
        };
      });

      setSurveys(surveysResponse);
    });

    setLoading(false);
  }, [projectId]);

  return (
    <Container className={loading ? 'loading' : ''}>
      {state?.projectName ? (
        <>
          <h1>{state?.projectName} - Surveys</h1>
        </>
      ) : (
        <h1>Surveys</h1>
      )}

      <Link to={`/surveys/new`} state={{ projectId }}>
        <Button variant="contained" type="button">
          New Survey
        </Button>
      </Link>

      {/* <Link
        to={{
          pathname: `/accesses/search`,
          state: { projectId },
        }}
      >
        <Button variant="contained" type="button">
          Search Link
        </Button>
      </Link> */}

      <Content>
        <Table
          columnsProp={columns}
          dataProp={surveys}
          checkboxSelection={false}
          tableColumnExtensions={tableColumnExtensions}
          actionColumns={actionColumns}
          hasFilterRow={true}
          idName={'surveyId'}
        ></Table>
      </Content>
    </Container>
  );
};

export default Surveys;
